export enum TradableDetailType {
	FIAT,
	PERCENTAGE,
	LEVERAGE
}

export interface TradableDetailInterface {
	label: string;
	translationKey: string;
	type: TradableDetailType;
	detailsKey?: string;
}
